import { render, staticRenderFns } from "./book-insight-example.vue?vue&type=template&id=738d3b38&"
import script from "./book-insight-example.vue?vue&type=script&lang=js&"
export * from "./book-insight-example.vue?vue&type=script&lang=js&"
import style0 from "./book-insight-example.vue?vue&type=style&index=0&id=738d3b38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports